var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      [
        _c(
          "j-select-biz-component",
          _vm._g(
            _vm._b(
              {
                attrs: {
                  value: _vm.value,
                  option: _vm.option,
                  name: this.$store.getters.language["role"],
                  displayKey: "roleName",
                  disabled: _vm.disabled,
                  returnKeys: _vm.returnKeys,
                  listUrl: _vm.listUrl,
                  columns: _vm.columns,
                  queryParamCode: "applicationName",
                  queryParamText: this.$store.getters.language[
                    "application.applicationName"
                  ]
                }
              },
              "j-select-biz-component",
              _vm.$attrs,
              false
            ),
            _vm.$listeners
          )
        )
      ],
      1
    ),
    _c(
      "div",
      [
        _c("a-modal", {
          attrs: { title: "Title", visible: _vm.visible, zIndex: 1005 }
        })
      ],
      1
    ),
    _c("div", {
      scopedSlots: _vm._u([
        {
          key: "action",
          fn: function(text, record) {
            return _c("span", {}, [
              _c("a", [
                _vm._v(_vm._s(this.$store.getters.language["common.edit"]))
              ])
            ])
          }
        }
      ])
    })
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }